import { createActionGroup, props } from '@ngrx/store';
import { ForgotType } from 'src/app/models/login';

export const LoginActions = createActionGroup({
  source: 'Login',
  events: {
    'Set Forgot Type': props<{ forgotType: ForgotType }>(),
  },
});
